import { NotificationInstance } from "antd/es/notification/interface";

export default class Funciones {
    static mostrarNotificacion(notification: NotificationInstance, titulo: string, mensaje: string, tipo: "success" | "info" | "warning" | "error"): void {
        notification.open({
            type: tipo,
            message: titulo,
            description: mensaje,
            placement: "bottomRight"
        });
    }
}